var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"subtitle-1",attrs:{"timeout":_vm.timeout,"color":_vm.snackColor},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.snack)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }